import React, { useState } from "react";
import { Container, Table, Row, Col, Button } from "react-bootstrap";
import { FiPlus, FiSearch } from "react-icons/fi";
import { Link } from "react-router-dom";

const periodTimings = [
  "09:00 – 09:45",
  "09:45 – 10:30",
  "10:30 – 11:15",
  "11:15 – 11:30",
  "11:30 – 12:15",
  "12:15 – 01:00",
];

const timetableData = {
  week1: [
    { day: "Monday", p1: "Maths", p2: "English", p3: "Science", p4: "Break", p5: "Social", p6: "Computer" },
    { day: "Tuesday", p1: "English", p2: "Maths", p3: "Science", p4: "Break", p5: "Tamil", p6: "Sports" },
    { day: "Wednesday", p1: "Science", p2: "Maths", p3: "English", p4: "Break", p5: "Social", p6: "Library" },
    { day: "Thursday", p1: "Maths", p2: "English", p3: "Computer", p4: "Break", p5: "Science", p6: "Tamil" },
    { day: "Friday", p1: "English", p2: "Maths", p3: "Science", p4: "Break", p5: "Social", p6: "Sports" },
  ],

  week2: [
    { day: "Monday", p1: "Tamil", p2: "Maths", p3: "English", p4: "Break", p5: "Science", p6: "Computer" },
    { day: "Tuesday", p1: "Maths", p2: "Science", p3: "English", p4: "Break", p5: "Social", p6: "Sports" },
    { day: "Wednesday", p1: "English", p2: "Maths", p3: "Science", p4: "Break", p5: "Library", p6: "Tamil" },
    { day: "Thursday", p1: "Science", p2: "English", p3: "Maths", p4: "Break", p5: "Computer", p6: "Social" },
    { day: "Friday", p1: "Maths", p2: "Tamil", p3: "Science", p4: "Break", p5: "English", p6: "Sports" },
  ],
};

export default function Timetable() {
  const [week, setWeek] = useState("week1");

  return (
    <Container>
      {/* Header */}
      <div className="staff-header">
        <div className="staff-breadcrumb">
          <Link to="/institute/home" className="crumb home">Home</Link>
          <span className="crumb current">Monthly Timetable</span>
        </div>

        <div className="staff-header-right">
          <Link to="#" className="btn-submit">
            <FiPlus size={15} /> Add Timetable
          </Link>
        </div>
      </div>

      {/* Card */}
      <div className="staff-card">
        <Row className="align-items-center mb-3">
          <Col md={4}>
            <h6 className="staff-card-title">
              Class Timetable – {week === "week1" ? "Week 1" : "Week 2"}
            </h6>
            <small className="text-muted">Month: January</small>
          </Col>

          <Col md={8} className="d-flex justify-content-end gap-2">
            <Button
              size="sm"
              variant={week === "week1" ? "primary" : "outline-primary"}
              onClick={() => setWeek("week1")}
            >
              Week 1
            </Button>

            <Button
              size="sm"
              variant={week === "week2" ? "primary" : "outline-primary"}
              onClick={() => setWeek("week2")}
            >
              Week 2
            </Button>

            <div className="staff-search ms-3">
              <FiSearch />
              <input placeholder="Search by day" />
            </div>
          </Col>
        </Row>

        {/* Timetable Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle text-center">
            <thead>
              <tr>
                <th>Day</th>
                <th>
                  Period 1
                  <div className="text-muted small">{periodTimings[0]}</div>
                </th>
                <th>
                  Period 2
                  <div className="text-muted small">{periodTimings[1]}</div>
                </th>
                <th>
                  Period 3
                  <div className="text-muted small">{periodTimings[2]}</div>
                </th>
                <th>
                  Break
                  <div className="text-muted small">{periodTimings[3]}</div>
                </th>
                <th>
                  Period 4
                  <div className="text-muted small">{periodTimings[4]}</div>
                </th>
                <th>
                  Period 5
                  <div className="text-muted small">{periodTimings[5]}</div>
                </th>
              </tr>
            </thead>

            <tbody>
              {timetableData[week].map((row, index) => (
                <tr key={index}>
                  <td><strong>{row.day}</strong></td>
                  <td>{row.p1}</td>
                  <td>{row.p2}</td>
                  <td>{row.p3}</td>
                  <td className="text-success fw-bold">{row.p4}</td>
                  <td>{row.p5}</td>
                  <td>{row.p6}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
}
